import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios";
// TODO: delete and replace with query

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async ({ search, status }) => {
    const params = {};

    if (search) params.search = search;
    if (status) params.status = status;

    const response = await axiosInstance.get("/products", { params: params });

    return {
      data: response.data,
    };
  }
)

const productsSlice = createSlice({
  name: "products",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  }
});

export default productsSlice.reducer;